import $ from 'jquery';


let isRecaptchaSuccess = false;
let resumeBlockElement = null;
let submitButtonElement = null;

const resumeRecaptchaCallback = function(response) {
    isRecaptchaSuccess = !!response;

    submitButtonElement[validateRequiredField(resumeBlockElement) ? 'removeAttr' : 'attr']('disabled', true);

    if (isRecaptchaSuccess) {
        resetError(resumeBlockElement, '#resume-error-g-recaptcha-response');
    }
}


const validateRequiredField = function($popup, target = null) {
    let state = true;
    const $inputs = $popup.find('input, textarea, select').filter(':not([disabled])').filter('[required]');

    if (target) {
        resetError($popup, '#resume-error-' + target.name);
    }

    if($inputs.length) {
        $inputs.each((idx, input) => {
            if (input.type === 'checkbox') {
                if (!input.checked) {
                    state = false;
                    return false;
                }
            } else if (input.type === 'file') {
                if (!input.files.length) {
                    state = false;
                    return false;
                }
            } else {
                if(!input.value.trim() || input.value === '__placeholder__') {
                    state = false;
                    return false;
                }
            }
        })
    }

    return state && isRecaptchaSuccess;
}

const resetError = function ($popup, selector) {
    if ($popup.find(selector).is(':visible')) {
        $popup.find(selector).text('').hide();
    }
}

const resetErrors = function($popup) {
    const $inputs = $popup.find('input, textarea, select').filter(':not([disabled])').filter('[required]');

    if($inputs.length) {
        $inputs.each((idx, input) => {
            resetError($popup, '#resume-error-' + input.name);
        })
    }

    resetError($popup, '#resume-error-unknown');
}



const showErrors = function($popup, errors) {
    let found = false;
    $.each(errors, (name, messages) => {
        let element = $popup.find('#resume-error-' + name);
        if (element) {
            element.text(messages[0]).show();
            found = true;
        }
    })
    if (!found) {
        $popup.find('#resume-error-unknown').text('Неизвестная ошибка').show();
    }
}

const resumeHandler = function(resumeBlock) {
    if (resumeBlock.length === 0) {
        return;
    }

    const $showFormButton = $('.show_resume_form_button');

    $showFormButton.on('click', function() {
       if ($showFormButton.hasClass('disabled')) {
           return;
       }

        resumeBlock.find('.resume_form_wrapper').show();

        if (!$showFormButton.hasClass('open-popup')) {
            $showFormButton.addClass('disabled');
        }
    });

    let jobIds = JSON.parse(localStorage.getItem('job_ids') || '[]');
    const jobId = $('input[name="job_id"]').val();
    if (jobId && jobIds.includes(jobId)) {
        if (!$showFormButton.hasClass('open-popup')) {
            $showFormButton.addClass('disabled');
        }
        resumeBlock.find('.resume_form_wrapper').hide();
        resumeBlock.find('.resume_already_send').show();

        return;
    } else {
        resumeBlock.find('.resume_already_send').hide();
    }

    resumeBlockElement = resumeBlock;
    const $submitButton = resumeBlock.find('button[type="submit"]');
    submitButtonElement = $submitButton;
    $submitButton['attr']('disabled', true);

    resumeBlock.on('change input', 'input, textarea, select', function(e) {
        $submitButton[validateRequiredField(resumeBlock, e.target) ? 'removeAttr' : 'attr']('disabled', true);
    });

    resumeBlock.on('reset', function() {
        $submitButton[validateRequiredField(resumeBlock) ? 'removeAttr' : 'attr']('disabled', true);
        const recaptchaId = resumeBlock.find('.g-recaptcha').data('recaptcha-id');
        if (recaptchaId !== undefined) {
            grecaptcha.reset(recaptchaId);
        }
    })

    let isBusy = false;
    resumeBlock.find('form').on('submit', function(e) {
        const form = this;

        e.preventDefault();

        if(isBusy) {
            return;
        }

        resetErrors(resumeBlock);
        isBusy = true;

        form.classList.add('_is-busy');

        $.ajax({
            url: form.action,
            type: 'post',
            data: new FormData(resumeBlock.find('form')[0]),
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
                if(Object.hasOwn(response, 'success')) {
                    if (!jobId) {
                        resumeBlock.find('.resume_form_wrapper').hide();
                        resumeBlock.find('.resume_already_send').show();
                        $showFormButton.addClass('disabled');
                    }

                    if (jobId && !jobIds.includes(jobId)) {
                        jobIds.push(jobId);
                        localStorage.setItem('job_ids', JSON.stringify(jobIds));

                        resumeBlock.find('.resume_form_wrapper').hide();
                        resumeBlock.find('.resume_already_send').show();
                        $showFormButton.addClass('disabled');
                    }

                    $.popup.info(['Резюме успешно отправлено.'], {center: true});

                    setTimeout(() => {
                        isBusy = false;
                        form.classList.remove('_is-busy');
                        form.reset();
                    }, 600);
                }
            },
            error: function(response) {
                isBusy = false;
                form.classList.remove('_is-busy');
                const recaptchaId = resumeBlock.find('.g-recaptcha').data('recaptcha-id');
                if (recaptchaId !== undefined) {
                    grecaptcha.reset(recaptchaId);
                }
                isRecaptchaSuccess = false;
                $submitButton[validateRequiredField(resumeBlock) ? 'removeAttr' : 'attr']('disabled', true);

                var data = JSON.parse(response.responseText);
                showErrors(resumeBlock, Object.hasOwn(data, 'errors') ? data.errors : []);
            }
        })
    });
};

export {
    resumeHandler,
    resumeRecaptchaCallback
};
